export default __webpack_public_path__ + "static/nocn-008c2b4cd19890e5cd90728addabab12.png";